export default "__VITE_ASSET__4b6d93d0__"